import { Fragment } from "react";
import { Citation, Footnote } from "./types";
import ReferenceBadge from "./ReferenceBadge";
import { Space } from "antd";

interface Props {
    citations?: Citation[];
    footnotes?: Footnote[];
}

function getIdRanges(citations: Citation[]) {
    const ids = citations.map(c => c.id);

    const result = [];
    let start = ids[0];
    let end = ids[0];

    for (let i = 1; i <= ids.length; i++) {
        if (ids[i] === end + 1) {
            end = ids[i];
        } else {
            result.push(start === end ? `${start}` : `${start}-${end}`);
            start = ids[i];
            end = ids[i];
        }
    }

    return result;
}

const InlineSources: React.FC<Props> = ({
    citations = [],
    footnotes = [],
}) => {

    return (
        <Fragment>
            {(citations.length > 0 || footnotes.length > 0) && (
                <Space size={5} style={{ margin: '0px 3px 0px 3px' }}>
                    {citations.length <= 3 ? (
                        <Fragment>
                            {citations.map(citation => (
                                <ReferenceBadge
                                    key={citation.id}
                                >
                                    {citation.id}
                                </ReferenceBadge>
                            ))}
                        </Fragment>
                    ) : (
                        <ReferenceBadge>
                            {getIdRanges(citations).join(', ')}
                        </ReferenceBadge>
                    )}
                    {footnotes.length <= 1 ? (
                        <Fragment>
                            {footnotes.map(footnote => (
                                <ReferenceBadge
                                    key={footnote.symbol}
                                >
                                    {footnote.symbol}
                                </ReferenceBadge>
                            ))}
                        </Fragment>
                    ) : (
                        <ReferenceBadge>
                            {footnotes
                                .map(footnote => footnote.symbol)
                                .join(' ')}
                        </ReferenceBadge>
                    )}
                </Space>
            )}
        </Fragment>
    );
};

export default InlineSources;